import Backbone from 'backbone';

Backbone.$ = $;

export default Backbone.View.extend({
  hide() {
    this.$el.css('display', 'none');
  },
  show() {
    this.$el.css('display', '');
  },
});
